<search-bar [showButtonLoader]="showButtonLoader" (onSearch)="searchFAQs($event)" (onClear)="getFaqs()"></search-bar>
<generic-container [titleKey]="faqTitleKey" textAlign="left">
  <faq [faqs]="faqData" [faqLimit]="7" [showFeedback]="true" [groupLabels]="true"></faq>
</generic-container>
<support-videos [videos]="videosData" (categoryChange)="getVideos($event)"></support-videos>
<div class="background-color-alice-blue">
  <support-contact-us></support-contact-us>
</div>
